<template>
  <div class="dashboard">
    <div class="titleMobile">
      <span>Resumo Principal</span>
    </div>
    <div class="contentCard">
      <div class="cardItemSimle" style="border-right: 3px solid purple">
        <div class="textHeader">Usuários Internos</div>
        <div v-if="spinGeneral" class="card_content">
          <b-spinner class="spin"></b-spinner>
        </div>
        <div v-else class="card_content" style="color: purple">
          {{ this.count.internal }}
        </div>
      </div>
      <div class="cardItemSimle" style="border-right: 3px solid #0188c8">
        <div class="textHeader">Usuários Externos</div>
        <div v-if="spinGeneral" class="card_content">
          <b-spinner class="spin"></b-spinner>
        </div>
        <div v-else class="card_content" style="color: #0188c8">
          {{ this.count.external }}
        </div>
      </div>
      <div class="cardItem" style="border-right: 3px solid green">
        <div style="display: flex; flex-direction: column; width: 80%">
          <div class="textHeader">Cursos Cadastrados</div>
          <div v-if="spinGeneral" class="card_content">
            <b-spinner class="spin"></b-spinner>
          </div>
          <div v-else class="card_content" style="color: green">
            {{ this.countCourses.length }}
          </div>
        </div>
        <div
          @click="generateCoursesReport"
          style="
            width: 20%;
            height: 100%;
            background: green;
            color: white;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
          "
        >
          <b-icon-printer-fill scale="1.2"></b-icon-printer-fill>
        </div>
      </div>
      <div class="cardItem" style="border-right: 3px solid red">
        <div style="display: flex; flex-direction: column; width: 80%">
          <div class="textHeader">Alunos Cadastrados</div>
          <div v-if="spinGeneral" class="card_content">
            <b-spinner class="spin"></b-spinner>
          </div>
          <div v-else class="card_content" style="color: red">
            {{ this.countstudents.length }}
          </div>
        </div>
        <div
          @click="generateStudentsReport"
          style="
            width: 20%;
            height: 100%;
            background: red;
            color: white;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
          "
        >
          <b-icon-printer-fill scale="1.2"></b-icon-printer-fill>
        </div>
      </div>
    </div>
    <div class="contentGraphics">
      <img class="gifImage" :src="dashboard" />
    </div>
  </div>
</template>
<script>
import jsPDF from "jspdf";
import "jspdf-autotable";
import dashboard from "../../assets/dashboard.gif";
import CourseService from "../../services/course";

export default {
  data() {
    return {
      count: {},
      dashboard: dashboard,
      spinGeneral: false,
      countCourses: [],
      countstudents: [],
    };
  },
  methods: {
    async countUsers() {
      const { data } = await CourseService.getUserCount();
      this.count = data;
    },
    async readCourses() {
      try {
        const { data } = await CourseService.comboboxCourses();

        this.countCourses = data;
      } catch (error) {
        this.$toast.open({
          message: "Não foi possível listar os clientes",
          type: "info",
        });
      }
    },
    async readUsers() {
      try {
        this.spinGeneral = true;
        const { data } = await CourseService.comboboxStudents();

        this.countstudents = data;
      } catch (error) {
        this.$toast.open({
          message: "Não foi possível listar os clientes",
          type: "info",
        });
      } finally {
        this.spinGeneral = false;
      }
    },
    generateCoursesReport() {
      const doc = new jsPDF();
      const rows = this.countCourses.map((course) => [course.name]);

      doc.text("Relatório de Cursos Cadastrados", 10, 10);
      doc.autoTable({
        head: [["Nome do Curso"]],
        body: rows,
        startY: 20,
      });
      doc.save("Relatorio_Cursos.pdf");
    },
    generateStudentsReport() {
      const doc = new jsPDF();
      const rows = this.countstudents.map((student) => [student.name]);

      doc.text("Relatório de Alunos Cadastrados", 10, 10);
      doc.autoTable({
        head: [["Nome do Aluno"]],
        body: rows,
        startY: 20,
      });
      doc.save("Relatorio_Alunos.pdf");
    },
  },
  mounted() {
    this.countUsers();
    this.readCourses();
    this.readUsers();
  },
};
</script>
<style scoped>
.dashboard {
  width: 85%;
  margin-top: 100px;
  display: flex;
  flex-direction: column;
  gap: 50px;
}

.titleMobile {
  display: none;
}

.contentCard {
  display: flex;
  justify-content: space-evenly;
  height: 80px;
}

.cardItem {
  width: 23%;
  height: 60px;
  display: flex;
  border-radius: 5px;
  border: 1px solid #d1d2d5;
  background: white;
  align-items: center;
  justify-content: space-around;
}

.cardItemSimle {
  width: 23%;
  height: 60px;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  border: 1px solid #d1d2d5;
  background: white;
  align-items: center;
  justify-content: space-around;
}

.textHeader {
  text-align: center;
  font-size: 12px;
  padding: 0 6px;
  cursor: context-menu;
  font-weight: 600;
}

.card_content {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  font-size: 14px;
  font-weight: 600;
}

.spin {
  height: 20px;
  width: 20px;
}

a {
  color: rgb(37, 37, 37);
  text-decoration: none;
}
a:hover {
  color: rgb(37, 37, 37);
  text-decoration: none;
}

.entrancExit {
  width: 48%;
  height: 100%;
  background: white;
  border-radius: 3px;
  border: 2px solid #b3b4b7;
  box-shadow: 0px 12px 4px -10px rgba(142, 142, 142, 0.78);
  border-radius: 5px;
  border: 1px solid #d1d2d4;
  z-index: 500;
  background: #ffffffab;
}
.entrancExit:hover {
  background: #f9f9f9ab;
}

.otherInfos {
  display: flex;
  width: 48%;
  gap: 10px;
  justify-content: center;
  background: white;
  z-index: 500;
  background: #ffffffab;
}
.otherInfos:hover {
  background: #f9f9f9ab;
}

.listFInencer {
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  gap: 2px;
  padding: 10px;
  height: 80%;
  border-top: 1px solid #d2d4d8;
}

.otherInfoItem {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  gap: 2px;
  padding: 10px;
  width: 50%;
  border: 1px solid #d2d4d8;
  box-shadow: 0px 12px 4px -10px rgba(142, 142, 142, 0.78);
}

.titleList {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 11px;
  font-weight: 600;
  width: 100%;
  height: 40px;
  text-align: center;
  background: #f1f1f1;
}

.birthday {
  width: 30px;
  height: 30px;
}

.contentOther {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 80%;
  width: 100%;
  background: #e5e6e9;
}

.contentMonth {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 80%;
  width: 100%;
  overflow: auto;
  max-height: 200px;
  background: #e5e6e9;
}

.contentOtherItem {
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 11px;
  height: 30px;
  min-height: 30px;
  width: 100%;
}

.contentOtherItem span {
  text-align: center;
}

.itemEllipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: default;
}

.numberList {
  font-size: 25px;
  font-weight: 600;
}

.itemList {
  display: flex;
  border-radius: 3px;
  height: 60px;
  border: 1px solid #d2d4d8;
  font-size: 11px;
  cursor: pointer;
}

.itemList span {
  width: 25%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.entrancExitValue {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  color: rgb(182, 8, 8);
  font-weight: 600;
  font-size: 14px;
}
.entrancValue {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  color: rgb(78, 182, 8);
  font-size: 14px;
  font-weight: 600;
}

.contentGraphics {
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  height: 45vh;
}

.gifImage {
  width: 450px;
  height: 400px;
}

.contentOtherInfos {
  justify-content: space-evenly;
  display: flex;
  margin: 15px 0;
  padding-bottom: 20px;
}

.cardGraphicNull {
  width: 48%;
  max-width: 48%;
  height: 100%;
  border-radius: 3px;
  gap: 10px;
  border: 2px solid #b3b4b7;
  z-index: 500;
  background: #ffffffab;
  display: flex;
  justify-content: center;
  align-items: center;
}

.cardGraphic1 {
  width: 48%;
  max-width: 48%;
  padding-top: 20px;
  height: 100%;
  border-radius: 3px;
  border: 2px solid #b3b4b7;
  z-index: 500;
  background: #ffffffab;
}

.cardGraphic1Null {
  width: 48%;
  max-width: 48%;
  height: 100%;
  border-radius: 3px;
  gap: 10px;
  border: 2px solid #b3b4b7;
  z-index: 500;
  background: #ffffffab;
  display: flex;
  justify-content: center;
  align-items: center;
}

.rocketBkg {
  width: 400px;
  height: 400px;
  background: transparent;
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 20;
  margin: 0 50px 0 0;
  opacity: 0.5;
}

.containerSchedule {
  display: flex;
  flex-direction: column;
  position: absolute;
  bottom: 20px;
  width: 300px;
  height: 50vh;
  right: 20px;
  align-items: center;
  justify-content: center;
}

.btnSchedule {
  cursor: pointer;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  width: 50px;
  height: 50px;
  bottom: 0px;
  right: 0px;
  border-radius: 50%;
  background: #efefef;
  box-shadow: 0px 1px 4px 1px rgba(142, 142, 142, 0.78);
}

.countEvents {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 40px;
  right: 0px;
  background: rgb(68, 68, 68);
  color: white;
  font-size: 10px;
  border-radius: 50%;
  width: 20px;
  height: 20px;
}

.btnsPaginate {
  background-color: white;
  box-shadow: #00000040 0 1px 3px 0;
  width: 20px;
  height: 20px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-top: 0.5rem;
  font-size: 13px;
}

.btnsPaginate:hover {
  background-color: rgb(244, 244, 244);
}

.contentSchedule {
  width: 250px;
  height: 100%;
  max-height: 50vh;
  overflow: auto;
  display: flex;
  position: absolute;
  background: white;
  right: 10px;
  bottom: 60px;
  border: none;
  border-radius: 5px;
  flex-direction: column;
  align-items: center;
  padding: 0;
  z-index: 1000;
  box-shadow: 0px 1px 4px 1px rgba(142, 142, 142, 0.78);
  transition: ease-in all 0.3s;
}

.disabledContent {
  height: 0;
  width: 250px;
  position: absolute;
  visibility: hidden;
  transition: ease-in all 0.3s;
  /* animation: example 3s; */
}

.titleSchedule {
  font-size: 14px;
  text-align: center;
  padding: 10px 0;
}

.descriptionSchedule {
  color: #818181;
  font-size: 12px !important;
  font-style: normal !important;
  font-weight: 100 !important;
  display: flex;
  flex-wrap: wrap;
}

.rowScedule {
  width: 100%;
  padding: 5px;
  border-radius: 5px;
  border: 1px solid rgb(221, 221, 221);
  gap: 5px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.hourSchedule {
  font-size: 16px;
  padding: 10px;
  border-radius: 50px;
  background: #ebeaea;
}

.hourScheduleMonth {
  font-size: 11px;
  padding: 2px 10px;
  border-radius: 50px;
  background: #d2d2d2;
  display: flex;
  justify-content: center;
  align-items: center;
}

.rowScedule span {
  font-weight: bold;
  font-size: 13px;
  display: flex;
  margin-bottom: 0rem !important;
  font-style: oblique;
}

.contentTerms {
  display: flex;
  height: 70vh;
  position: relative;
  flex-direction: column;
  align-items: center;
}

.titleTerms {
  font-size: 23px;
  text-align: center;
}

.textTerms {
  display: flex;
  flex-direction: column;
  text-align: justify;
  font-size: 12px;
  gap: 20px;
  font-weight: bold;
  overflow: auto;
  padding: 30px 40px 20px 40px;
}

.checkbox-wrapper-46 input[type="checkbox"] {
  display: none;
  visibility: hidden;
}

.checkbox-wrapper-46 .cbx {
  margin: auto;
  -webkit-user-select: none;
  user-select: none;
  cursor: pointer;
}
.checkbox-wrapper-46 .cbx span {
  display: inline-block;
  vertical-align: middle;
  transform: translate3d(0, 0, 0);
}
.checkbox-wrapper-46 .cbx span:first-child {
  position: relative;
  width: 18px;
  height: 18px;
  border-radius: 3px;
  transform: scale(1);
  vertical-align: middle;
  border: 1px solid #9098a9;
  transition: all 0.2s ease;
}
.checkbox-wrapper-46 .cbx span:first-child svg {
  position: absolute;
  top: 3px;
  left: 2px;
  fill: none;
  stroke: #ffffff;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 16px;
  stroke-dashoffset: 16px;
  transition: all 0.3s ease;
  transition-delay: 0.1s;
  transform: translate3d(0, 0, 0);
}
.checkbox-wrapper-46 .cbx span:first-child:before {
  content: "";
  width: 100%;
  height: 100%;
  background: #506eec;
  display: block;
  transform: scale(0);
  opacity: 1;
  border-radius: 50%;
}
.checkbox-wrapper-46 .cbx span:last-child {
  padding-left: 8px;
}
.checkbox-wrapper-46 .cbx:hover span:first-child {
  border-color: #506eec;
}

.checkbox-wrapper-46 .inp-cbx:checked + .cbx span:first-child {
  background: #00486e;
  border-color: #506eec;
  animation: wave-46 0.4s ease;
}
.checkbox-wrapper-46 .inp-cbx:checked + .cbx span:first-child svg {
  stroke-dashoffset: 0;
}
.checkbox-wrapper-46 .inp-cbx:checked + .cbx span:first-child:before {
  transform: scale(3.5);
  opacity: 0;
  transition: all 0.6s ease;
}

@keyframes wave-46 {
  50% {
    transform: scale(0.9);
  }
}

.linkPdf {
  color: #007bff !important;
  text-decoration: underline;
  text-transform: uppercase;
}

.imgTerms {
  width: 275px;
  height: 150px;
  padding-right: 30px;
}

.btnModalTerms {
  width: 100%;
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 0;
  justify-content: space-around;
}

.btnContent {
  font-size: 11px;
  border: 1px solid #00486e;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #00486e;
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .textHeader {
    font-size: 10px;
    padding: 2px 0px;
  }
  .card_content {
    font-size: 11px;
  }
  .cardItem {
    height: 40px;
  }
  .contentGraphics {
    margin-top: 20px;
  }
  .rocketBkg {
    width: 250px;
    height: 250px;
  }
  .contentOtherInfos {
    justify-content: space-evenly;
    display: flex;
    margin: 15px 0;
    padding-bottom: 0px;
    height: 30vh;
  }
  .entrancValue {
    font-size: 12px;
  }
  .entrancExitValue {
    font-size: 12px;
  }
  .listFInencer {
    gap: 1px;
    padding: 3px;
    height: 85%;
  }
  .titleList {
    font-size: 10px;
    height: 25px;
  }
  .itemList {
    height: 30px;
    font-size: 10px;
  }
  .contentOther {
    font-size: 13px;
  }
  .birthday {
    width: 17px;
    height: 17px;
  }
  .numberList {
    font-size: 14px;
  }
}

@media screen and (max-width: 700px) {
  .contentGraphics {
    display: none;
  }

  .contentCard {
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    align-items: center;
    flex-wrap: nowrap;
    gap: 20px;
    align-content: center;
  }
  .cardItem {
    width: 80%;
  }
  .entrancExit {
    width: 80%;
  }
  .titleMobile {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    font-size: 23px;
    font-weight: bold;
    color: #212121;
    padding: 0px 0px 20px 0px;
  }
  .containerSchedule {
    display: none;
  }
  .contentOtherInfos {
    justify-content: center;
    align-items: center;
    display: flex;
    margin: 15px 0;
    padding-bottom: 20px;
    gap: 20px;
    height: auto;
    flex-direction: column;
  }
  .otherInfos {
    width: 100%;
    height: 100%;
  }
  .otherInfoItem {
    height: 40vh;
    max-height: 40vh;
  }
  .contentOther {
    font-size: 12px;
  }
}
</style>